/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//this is the button
var acc = document.getElementsByClassName("head-accordion");
var i;
for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
        var panel = this.nextElementSibling;
        var coursePanel = document.getElementsByClassName("body-accordion");
        var courseAccordion = document.getElementsByClassName("head-accordion");
        var courseAccordionActive = document.getElementsByClassName("head-accordion active");
        if (panel.style.maxHeight){
            panel.style.maxHeight = null;
            this.classList.remove("active");
        } 
        else { 
            for (var ii = 0; ii < courseAccordionActive.length; ii++) {
                courseAccordionActive[ii].classList.remove("active");
            }
            for (var iii = 0; iii < coursePanel.length; iii++) {
                this.classList.remove("active");
                coursePanel[iii].style.maxHeight = null;
            }
            panel.style.maxHeight = panel.scrollHeight + "px";
            this.classList.add("active");
        }
    }
}

/**
 * GTM-driven ecommerce events.
 * The theme only pushes clean dataLayer events; GA4 + Google Ads conversion tags
 * live in the GTM container (GTM-W24R5287), so consent and tag config stay in one place.
 * Purchase fires from the Shopify Customer Events web pixel, not here (checkout is out of theme scope).
 */
(function () {
  window.dataLayer = window.dataLayer || [];

  function currencyCode() {
    try {
      return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    } catch (e) { return 'EUR'; }
  }

  // Shopify prices are integer cents
  function money(cents) { return Math.round(Number(cents) || 0) / 100; }

  function lineItem(item, quantity, index) {
    var data = {
      item_id: String(item.sku || item.variant_id || ''),
      item_name: item.product_title || item.title || '',
      item_variant: item.variant_title || '',
      price: money(item.final_price != null ? item.final_price : item.price),
      quantity: quantity
    };
    if (index != null) data.index = index;
    return data;
  }

  function pushItemEvent(eventName, items) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      ecommerce: {
        currency: currencyCode(),
        value: items.reduce(function (sum, item) { return sum + item.price * item.quantity; }, 0),
        items: items
      }
    });
  }

  // Cached cart so begin_checkout can push synchronously on click (before navigation)
  var cart = null;
  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; })
      .catch(function () {});
  }
  refreshCart();
  document.addEventListener('cart:refresh', refreshCart);
  document.documentElement.addEventListener('cart:refresh', refreshCart);

  // add_to_cart — hooks the theme's documented 'product:added' event
  document.addEventListener('product:added', function (event) {
    var variant = event.detail && event.detail.variant;
    var quantity = (event.detail && event.detail.quantity) || 1;
    if (!variant) return;

    var fullName = variant.name || variant.title || '';
    var variantTitle = variant.public_title || '';
    var productName = (variantTitle && fullName.indexOf(' - ' + variantTitle) > -1)
      ? fullName.replace(' - ' + variantTitle, '')
      : fullName;

    pushItemEvent('add_to_cart', [{
      item_id: String(variant.sku || variant.id || ''),
      item_name: productName,
      item_variant: variantTitle,
      price: money(variant.price),
      quantity: quantity
    }]);

    refreshCart();
  });

  // Cart drawer quantity/remove controls post to /cart/change.js without a theme event, so diff the returned cart
  function trackCartChange(previous, next) {
    var before = {};
    (previous.items || []).forEach(function (item) { before[item.key] = item; });

    var added = [], removed = [];
    (next.items || []).forEach(function (item) {
      var delta = item.quantity - (before[item.key] ? before[item.key].quantity : 0);
      if (delta > 0) added.push(lineItem(item, delta));
      if (delta < 0) removed.push(lineItem(item, -delta));
      delete before[item.key];
    });
    Object.keys(before).forEach(function (key) {
      removed.push(lineItem(before[key], before[key].quantity));
    });

    if (added.length) pushItemEvent('add_to_cart', added);
    if (removed.length) pushItemEvent('remove_from_cart', removed);
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var promise = nativeFetch.apply(this, arguments);
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!/\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) return promise;

    return promise.then(function (response) {
      if (response.ok) {
        response.clone().json().then(function (next) {
          if (!next || !next.items) return;
          if (cart) trackCartChange(cart, next);
          cart = next;
        }).catch(function () {});
      }
      return response;
    });
  };

  // begin_checkout — fires when the customer proceeds to checkout (drawer + cart page)
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest &&
      event.target.closest('[name="checkout"], a[href$="/checkout"]');
    if (!trigger) return;

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'begin_checkout',
      ecommerce: cart ? {
        currency: cart.currency || currencyCode(),
        value: money(cart.total_price),
        // GA4 list positions are 1-based
        items: (cart.items || []).map(function (item, index) {
          return lineItem(item, item.quantity, index + 1);
        })
      } : { currency: currencyCode() }
    });
  }, true);
})();
